import React, { useEffect, useState, useRef } from 'react';
import '../css/ChatArea.css';
import '../css/ChatContainer.css';
import { MessageProvider } from './MessageContext';
import { useNavigate,useLocation } from 'react-router-dom';
import ChatMessage from './ChatMessage';
import Attention from './Attention';
import FirstUtterance from './FirstUtterance';
import ChatArea from './ChatArea';
import Navigation from './Navigation';
import NotebookList from './NotebookList';
import api from './api/api'; 

function ChatContainer({ initialChat, chatId, expandMargin, navigationExamples, updateChatSidebar, handleDashboardProcess }) {
  const ws = useRef(null);
  const pingInterval = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const notebookListRef = useRef(null); 
  const [chatAreas, setChatAreas] = useState([]); // 過去のチャットエリア
  const [showNavigationArea, setShowNavigationArea] = useState(false); // ナビゲーションエリアの表示/非表示
  const [showNotebookList, setShowNotebookList] = useState(false);
  const [expandLastChatArea, setExpandLastChatArea] = useState(true); // チャットエリアの高さの調整用
  const [chatHistoryId, setchatHistoryId] = useState(null);
  const [pdfPathList, setPdfPathList] = useState([]);
  const [savedNavigationState, setSavedNavigationState] = useState({
    role: false,
    selectedTodo: null,
    selectedTodoStep: null,
    showAnalysisStep: false,
    showPrompt: false,
    showAnalysisPrompt: false,
    selectedStep: null, // selectedStepも保存
  });
  const [nextQuestions, setNextQuestions] = useState([""]);
  const [nextQuestion, setNextQuestion] = useState('')
  const navigationRef = useRef(null);
  const lastChatAreaRef = useRef(null);
  const [showAgent, setShowAgent] = useState([]);
  const [showSpinner, setShowSpinner] = useState(false);
  const [response, setResponse] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [graphs, setGraphs] = useState([])
  const [graphHistory, setGraphHistory] = useState([]);
  const [latestChatHistoryId, setLatestChatHisotryId] = useState(0);
  const [disableChat, setDisableChat] = useState(false);

  const setupWebSocket = () => {
    if (ws.current && (ws.current.readyState === WebSocket.OPEN || ws.current.readyState === WebSocket.CONNECTING)) {
      ws.current.close();
    }
    
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    if (!ws.current || ws.current.readyState !== WebSocket.OPEN) {
      ws.current = new WebSocket(`${protocol}://${process.env.REACT_APP_WS_URL}/ws/chat/${chatId}/`);
    }
    
    ws.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.operation_type === 'utterance') {
        setResponse(data.operation);
      } else if (data.operation_type === 'dashboard') {
        setResponse(data.operation);
        handleDashboardProcess(data.agent_name);
      } else if (data.operation_type === 'agent_operation') {
        if (data.operation === "add_agent") {
          setShowAgent(prevAgents => [...prevAgents, data.agent_name]);
        } else if (data.operation === 'remove_agent') {
          setShowAgent(prevAgents => [...prevAgents.slice(0, -1)]);
        }
      } else if (data.operation_type === "next-questions") {
        setNextQuestions(prevQuestions => {
          const updatedQuestions = [...prevQuestions];
          updatedQuestions[updatedQuestions.length - 1] = data.operation.replace('- ', '');
          if (data.operation.includes("~")) {
            updatedQuestions[updatedQuestions.length - 1] = data.operation.replace("~", "").trim();
            updatedQuestions.push("");
          }
          return updatedQuestions;
        });
      } else if (data.operation_type === "graph_utterance") {
        const graphData = Object.entries(data.fig_data).map(([key, fig]) => ({ fig }));
        setGraphHistory(prevGraphs => {
          const newGraphs = [...prevGraphs];
          newGraphs[newGraphs.length - 1].push(...graphData);
          return newGraphs;
        });
      }
    };
  
    // ws.current.onopen = () => {
    //   // 30秒ごとにping送信
    //   pingInterval.current = setInterval(() => {
    //     if (ws.current.readyState === WebSocket.OPEN) {
    //       ws.current.send(JSON.stringify({ type: 'ping' }));
    //     }
    //   }, 30000);
    // };
  
    // ws.current.onclose = (event) => {
    //   clearInterval(pingInterval.current);
    // };
  
    ws.current.onerror = (event) => {
      console.error('WebSocket error:', event);
    };
  };
  
  
  useEffect(() => {
    setupWebSocket();
    return () => {
      if (ws.current && ws.current.readyState === WebSocket.OPEN) {
        ws.current.close();
      }
      clearInterval(pingInterval.current);
    };
  }, [chatId]);
  

  // initialChatが変わったらユーザ-アシスタントのペアの形にする
  useEffect(() => {
    const utterances = [];
    for (let i = 0; i < initialChat.length; i += 2) {
      const userUtterance = initialChat[i];
      const botUtterance = initialChat[i + 1] || null;
      utterances.push([userUtterance, botUtterance]);
    }

    if (initialChat.length > 0) {
        setLatestChatHisotryId(initialChat[initialChat.length - 1].chat_history_id);
    } else {
      setLatestChatHisotryId(0)
    }
    
    setChatAreas(utterances);
  }, [initialChat]);

  /* サーバにメッセージを送信する */
  const sendMessage = async (prompt, is_dashboard, is_main_chat, selectedCountry) => {
    // setShowSpinner(true);
    try {
      if (!ws.current || ws.current.readyState === WebSocket.CLOSED) {
        setupWebSocket();
      }

      const data = {
        task: 'action',
        prompt: prompt,
        is_dashboard: is_dashboard,
        is_main_chat: is_main_chat,
        country: selectedCountry ? selectedCountry : 'JP',
      };
    
      const response = await api.post(`${process.env.REACT_APP_API_URL}/chat/api/send-chat/${chatId}/`, data);
    
      if (response.data.pdf_path_list.length > 0) {
        setPdfPathList(response.data.pdf_path_list);
      }
    
      setDisableChat(false);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login', { state: { from: location.pathname } });
      } else {
        setErrMsg('申し訳ございません。処理の途中でエラーが発生しました。原因を調査し、対応できるように改善します。');
      }
      setDisableChat(false);
    }
  }

  // チャットエリアの追加
  const addChatArea = (userMessage, selectedCountry) => {
    setDisableChat(true);
    setPdfPathList([]);
    setShowNavigationArea(false);
    setExpandLastChatArea(true);
    setResponse('');
    setErrMsg('');
    setShowAgent([]);
    setNextQuestions([""]);
    setNextQuestion('');
    setGraphHistory(prevGraphs => {
        const existingGraphs = [...prevGraphs];
        existingGraphs.push([]); // 最後の要素に対してpush
        return existingGraphs;
    })

    if (latestChatHistoryId === 0) {
        updateChatSidebar(chatId, userMessage);
    }

    setChatAreas(prevChatAreas => [
      ...prevChatAreas,
      [
        { is_user: true, chat_history_id: latestChatHistoryId + 1, utterance: userMessage, good: false, bad: false, feedback: '', selectedCoountry: selectedCountry },
        { is_user: false, chat_history_id: latestChatHistoryId + 2, utterance: '', good: false, bad: false, feedback: '', chat_evidence: [], chat_graph: [] ,selectedCoountry: selectedCountry}
      ]
    ]);
    setGraphs([]);
    sendMessage(userMessage, false, false, selectedCountry);
    setLatestChatHisotryId(prevId => prevId + 2);
  };

  /* ナビゲーションボタン押下時の処理 */
  const navigationClick = () => {
    setShowNavigationArea(!showNavigationArea);
    setExpandLastChatArea(showNavigationArea);
  };

  /* ナビゲーションエリアの表示 */
  useEffect(() => {
    if (showNavigationArea && navigationRef.current) {
      setTimeout(() => {
        navigationRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    } else if (lastChatAreaRef.current) {
      setTimeout(() => {
        try {
          lastChatAreaRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (error) {
          console.error('Scroll error:', error);
        }
      }, 100);
    }
  }, [showNavigationArea, chatAreas]);


  // Navigationエリアの状態を更新
  const updateNavigationState = (newState) => {
    setSavedNavigationState(prevState => ({ ...prevState, ...newState }));
  };

  // ノートへの保存処理
  const handleBookmarkClick = (historyId) => {
    setchatHistoryId(historyId);
    setShowNotebookList(true);
  }

  /* 既存のノートに保存する */
  const onSaveToExistingNotebookClick = async (noteId) => {
    try {
      const response = await api.post('/chat/api/save-to-note/', {
        chatId,
        chatHistoryId,
        noteId,
      });
      if (response.ok) {
      } else {
        console.error('Error saving feedback');
      }
    } catch (error) {
      console.error('Error saving eisting note', error);
    }
  }

  /* 新しいノートを作成する */
  const onCreateNewNotebookClick = async (title) => {
    const response = await api.post('/chat/api/new-note/', {
      title,
    });
    if (notebookListRef.current) {
      notebookListRef.current.fetchNotebookList();  // NotebookListコンポーネントのメソッドを呼び出してリストを更新
    }
  }

  /* goodボタン */
  const handleGoodClick = async (chatHistoryId, isGood) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/chat/api/update-good/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          chatId,
          chatHistoryId,
          good: isGood,
        }),
      });
      if (response.ok) {
      } else {
        console.error('Error saving feedback');
      }
    } catch (error) {
      console.error('Error saving good', error);
    }
  };

  /* badボタンボタン */
  const handleBadClick = async (chatHistoryId, isBad) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/chat/api/update-bad/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          chatId,
          chatHistoryId,
          bad: isBad,
        }),
      });
      if (response.ok) {
      } else {
        console.error('Error saving feedback');
      }
    } catch (error) {
      console.error('Error saving good', error);
    }
  }

  return (
    <MessageProvider>
      <div className={`content ${expandMargin ? "md:ml-[90px]" : ""}`}>
        <button className="prompt-help" onClick={navigationClick}>
          プロンプト例を表示
        </button>
        <div className="chat-container" data-chat-id={chatId}>
          {chatAreas.length > 0 ? (
            chatAreas.map((pair, index) => (
              <ChatArea
                key={index}
                pair={pair}
                expand={index + 1 === chatAreas.length && expandLastChatArea}
                ref={index + 1 === chatAreas.length ? lastChatAreaRef : null}
                onSaveClick={handleBookmarkClick} 
                onGoodClick={handleGoodClick}
                onBadClick={handleBadClick}
                response={index + 1 === chatAreas.length  ? response : ''} // 最後のChatAreaにだけresponseを渡す
                agents={index + 1 === chatAreas.length ? showAgent : []}
                pdfPathList={index + 1 === chatAreas.length ? pdfPathList : []}
                showSpinner={index + 1 === chatAreas.length && showSpinner}
                graphData={graphHistory[index]}
                nextQuestions={index + 1 === chatAreas.length && nextQuestions}
                errMsg={index + 1 === chatAreas.length  ? errMsg : ''} // 最後のChatAreaにだけresponseを渡す
              />
            ))
          ) : (
            <FirstUtterance expand={expandLastChatArea} />
          )}
          {showNavigationArea && (
            <Navigation
              ref={navigationRef}
              navigationExamples={navigationExamples}
              navigationState={savedNavigationState}
              updateNavigationState={updateNavigationState}
            />
          )}
        </div>
        <ChatMessage onSendMessage={addChatArea} disable={disableChat} />
        <Attention />
        { showNotebookList ? <NotebookList 
          ref={notebookListRef}
          onSaveToExistingNotebookClick={onSaveToExistingNotebookClick}  
          onCreateNewNotebookClick={onCreateNewNotebookClick}  
          onCancelClick={() => setShowNotebookList(false)} /> 
          : 
          null }
      </div>
    </MessageProvider>
  );
}

export default ChatContainer;
